import { Slider } from "./ui/slider";

const CHIPS = [15, 30, 45, 60, 90, 120];
const chipLabel = (d) => (d >= 60 ? `${Math.floor(d / 60)}h${d % 60 ? "30" : ""}` : `${d} min`);

export default function DurationPicker({ duration, setDuration }) {
  return (
    <section className="mt-10">
      <h2 className="font-extrabold text-2xl tracking-tight mb-4">Durée</h2>
      <div className="flex flex-wrap gap-2 mb-5">
        {CHIPS.map((d) => (
          <button
            key={d}
            data-testid={`duration-chip-${d}`}
            onClick={() => setDuration(d)}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold ${duration === d ? "sp-chip-active" : "sp-chip text-white"}`}
          >
            {chipLabel(d)}
          </button>
        ))}
      </div>
      <div className="bg-[#181818] rounded-lg p-5 flex items-center gap-6">
        <div data-testid="duration-value" className="font-black text-3xl tabular-nums w-28 shrink-0">
          {duration}<span className="text-[#B3B3B3] text-base font-bold"> min</span>
        </div>
        <Slider data-testid="duration-slider" value={[duration]} min={5} max={180} step={5} onValueChange={(v) => setDuration(v[0])} />
      </div>
    </section>
  );
}
